export default {"src":"/_next/static/media/logo.74adf918.svg","height":60,"width":52};